<app-header></app-header>
<div class="mainScrollContainer" [ngClass]="{ 'logged-in': user.email }">
  <router-outlet></router-outlet>
</div>
